var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"paging"},[_c('app-content-nav-link',{attrs:{"navLinkClass":"btn btn_back","link":_vm.parentLink,"text":_vm.parentLinkName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }